import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import * as moment from 'moment';
import { getDataSourceCountryList, SetDataSourceCountryList } from 'visa-store';
import { ReferenceLibraryService } from 'reference-library';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-pdf-step-preview',
  templateUrl: './pdf-step-preview.component.html',
  styleUrls: ['./pdf-step-preview.component.scss']
})
export class PdfStepPreviewComponent implements OnInit {
  htmlStructure = [];
  fromYear: string;
  toYear: string;
  countryList: any[];
  constructor(
    public config: DynamicDialogConfig,
    private referenceLibraryService: ReferenceLibraryService,
    private store: Store<any>
  ) {
    this.toYear = moment().add(5, 'years').format('YYYY');
    this.fromYear = moment().subtract(5, 'years').format('YYYY');
    this.getCountry();
  }

  ngOnInit(): void {
    //console.log("this.config.data",this.config.data);
    Array.from(new Set(this.config.data.map(x => x.numberOfRow))).forEach(x => {
      this.htmlStructure.push({
        row: x,
        columns: this.config.data.filter(y => y.numberOfRow === x),

      });
    });
  }

  getCountry() {
    this.store.pipe(select(getDataSourceCountryList))
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data && data.length > 0) {
          data.unshift({
            name: 'Select',
            code: null
          });
          this.countryList = data;
        } else {
          this.referenceLibraryService.getDataSource('COUNTRY', '')
            .pipe(take(1))
            .subscribe((response: any[]) => {
              if (response) {
                this.countryList = JSON.parse(JSON.stringify(response));
                this.countryList.unshift({
                  name: 'Select',
                  code: null
                });
              } else {
                this.countryList = [];
              }
              this.store.dispatch(new SetDataSourceCountryList(response || null));
            });
        }
      });
  }

  handleCountryChange(evt, element) {
    let countryCode = evt.value;
    this.referenceLibraryService.getStatesFromStore(countryCode)
      .pipe(take(1))
      .subscribe((states: any[]) => {
        if (states) {
          states.unshift({
            stateProvinceName: 'Select',
            stateProvinceCode: null
          });
          element.stateList = states;
        } else {
          this.referenceLibraryService.getStatesFromApi(countryCode)
            .pipe(take(1))
            .subscribe((data: any[]) => {
              if (data) {
                data.unshift({
                  stateProvinceName: 'Select',
                  stateProvinceCode: null
                });
                element.stateList = data;
              } else {
                element.stateList = [];
              }
            });
        }
      });
  }

}
